"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTireTypeEnumValueByName = exports.getBodyworkEnumValueByName = exports.getFuelTranslatedValue = exports.getFuelEnumValueByName = exports.QuantityType = exports.VehicleType = exports.TireType = exports.FilterGroup = exports.VehicleReserveStatus = exports.VehicleBodyworkType = exports.VehicleFuelType = void 0;
const utils_1 = require("../utils");
var VehicleFuelType;
(function (VehicleFuelType) {
    VehicleFuelType["ELECTRIC"] = "electric";
    VehicleFuelType["GASOLINE"] = "gasoline";
    VehicleFuelType["DIESEL"] = "diesel";
    VehicleFuelType["HYBRID"] = "hybrid";
})(VehicleFuelType = exports.VehicleFuelType || (exports.VehicleFuelType = {}));
var VehicleBodyworkType;
(function (VehicleBodyworkType) {
    VehicleBodyworkType["COUPE"] = "coupe";
    VehicleBodyworkType["SUV"] = "suv";
    VehicleBodyworkType["CABRIOLET"] = "cabriolet";
    VehicleBodyworkType["CITY"] = "city";
    VehicleBodyworkType["VAN"] = "van";
    VehicleBodyworkType["KOMBI"] = "kombi";
})(VehicleBodyworkType = exports.VehicleBodyworkType || (exports.VehicleBodyworkType = {}));
var VehicleReserveStatus;
(function (VehicleReserveStatus) {
    VehicleReserveStatus[VehicleReserveStatus["CANCELLATION_FAIL"] = 0] = "CANCELLATION_FAIL";
    VehicleReserveStatus[VehicleReserveStatus["WAITING"] = 1] = "WAITING";
    VehicleReserveStatus[VehicleReserveStatus["WAITING_CANCELLATION"] = 2] = "WAITING_CANCELLATION";
    VehicleReserveStatus[VehicleReserveStatus["RESERVED"] = 3] = "RESERVED";
    VehicleReserveStatus[VehicleReserveStatus["RESERVATION_FAIL"] = 4] = "RESERVATION_FAIL";
    VehicleReserveStatus[VehicleReserveStatus["RESERVATION_CANCELED"] = 5] = "RESERVATION_CANCELED";
})(VehicleReserveStatus = exports.VehicleReserveStatus || (exports.VehicleReserveStatus = {}));
var FilterGroup;
(function (FilterGroup) {
    FilterGroup["MODEL"] = "model";
    FilterGroup["BODYWORK"] = "bodywork";
    FilterGroup["FUELS"] = "fuels";
    FilterGroup["VARNISHES"] = "varnishes";
})(FilterGroup = exports.FilterGroup || (exports.FilterGroup = {}));
var TireType;
(function (TireType) {
    TireType["SPIKES"] = "spikes";
})(TireType = exports.TireType || (exports.TireType = {}));
var VehicleType;
(function (VehicleType) {
    VehicleType["PERSONBIL"] = "PER";
    VehicleType["VAREBIL"] = "VER";
})(VehicleType = exports.VehicleType || (exports.VehicleType = {}));
var QuantityType;
(function (QuantityType) {
    QuantityType[QuantityType["DARS_QUANTITY"] = 4] = "DARS_QUANTITY";
    QuantityType[QuantityType["QUANTITY"] = 1] = "QUANTITY";
})(QuantityType = exports.QuantityType || (exports.QuantityType = {}));
const getFuelEnumValueByName = (fuelType) => {
    if (typeof fuelType !== 'string') {
        return null;
    }
    switch (fuelType.toLowerCase()) {
        case 'elektrisk':
        case 'electric':
            return VehicleFuelType.ELECTRIC;
        case 'bensin':
        case 'gasoline':
            return VehicleFuelType.GASOLINE;
        case 'diesel':
            return VehicleFuelType.DIESEL;
        case 'hybrid':
            return VehicleFuelType.HYBRID;
        default:
            return null;
    }
};
exports.getFuelEnumValueByName = getFuelEnumValueByName;
const getFuelTranslatedValue = (fuelType, capitalize = false) => {
    let type = fuelType;
    if (typeof fuelType === 'string') {
        type = (0, exports.getFuelEnumValueByName)(fuelType);
    }
    let value = null;
    switch (type) {
        case VehicleFuelType.ELECTRIC:
            value = 'elektrisk';
            break;
        case VehicleFuelType.GASOLINE:
            value = 'bensin';
            break;
        case VehicleFuelType.DIESEL:
            value = 'diesel';
            break;
        case VehicleFuelType.HYBRID:
            value = 'hybrid';
            break;
        default:
            break;
    }
    return value && capitalize ? (0, utils_1.capitalizeFirstLetter)(value) : value;
};
exports.getFuelTranslatedValue = getFuelTranslatedValue;
const getBodyworkEnumValueByName = (bodyworkType) => {
    if (typeof bodyworkType != 'string') {
        return null;
    }
    switch (bodyworkType.toLowerCase()) {
        case 'coupe':
            return VehicleBodyworkType.COUPE;
        case 'suv':
            return VehicleBodyworkType.SUV;
        case 'cabriolet':
            return VehicleBodyworkType.CABRIOLET;
        case 'city':
            return VehicleBodyworkType.CITY;
        case 'van':
            return VehicleBodyworkType.VAN;
        case 'kombi':
            return VehicleBodyworkType.KOMBI;
        default:
            return null;
    }
};
exports.getBodyworkEnumValueByName = getBodyworkEnumValueByName;
const getTireTypeEnumValueByName = (tireType) => {
    if (typeof tireType != 'string')
        return null;
    switch (tireType.toLowerCase()) {
        case 'pigg':
            return TireType.SPIKES;
        default:
            return null;
    }
};
exports.getTireTypeEnumValueByName = getTireTypeEnumValueByName;
//# sourceMappingURL=vehicle.js.map